import React, { useState } from 'react';
import LoginServices from './AuthServices';
import Logo from '../../images/Frame 1321317892.png';
import { Link } from "react-router-dom";
import './LoginScreen.css';
const LoginScreen = () => {
  const [showPassword, setShowPassword] = useState(false);

  const {
    loginState,
    setEmail,
    setPassword,
    setRememberMe,
    handleLogin,
    status
  } = LoginServices();

  const { email, password, rememberMe } = loginState;

  return (
    <div className="container-fluid min-vh-100 d-flex align-items-center justify-content-center mainBgColor py-3">
      <div className="container">
        <div className="row justify-content-center">
          {/* Login Form Column */}
          <div className="col-12 col-md-6 mb-4">
            <div className="blurBG p-3 p-md-4 rounded">
              {/* Logo link */}
              <img className="img-fluid float-left login-logo" src={Logo} alt="LogoMarion" style={{ maxWidth: '70%' }} />
              <hr></hr>
              <h1 className="text-left mainColor fs-3 fs-md-1">Se connecter</h1>
              <form className='pt-3'>
                <div className="mb-3">
                  <input
                    type="text"
                    placeholder='Adresse e-mail'
                    className="form-control form-control-lg "
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
                <div className="position-relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    placeholder='Mot de passe:'
                    className="form-control form-control-lg"
                    id="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <button
                    type="button"
                    className="btn position-absolute top-50 end-0 translate-middle-y me-2"
                    style={{ border: 'none', background: 'transparent', padding: '0' }}
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? (
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.99902 3L20.999 21M9.8433 9.91364C9.32066 10.4536 8.99902 11.1892 8.99902 12C8.99902 13.6569 10.3422 15 11.999 15C12.8215 15 13.5667 14.669 14.1086 14.133M6.49902 6.64715C4.59972 7.90034 3.15305 9.78394 2.45703 12C3.73128 16.0571 7.52159 19 11.9992 19C13.9881 19 15.8414 18.4194 17.3988 17.4184M10.999 5.04939C11.328 5.01673 11.6617 5 11.9992 5C16.4769 5 20.2672 7.94291 21.5414 12C21.2607 12.894 20.8577 13.7338 20.3522 14.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    ) : (
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 19C16.4183 19 20.1628 16.1301 21.5 12C20.1628 7.86995 16.4183 5 12 5C7.58172 5 3.83719 7.86995 2.5 12C3.83719 16.1301 7.58172 19 12 19Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    )}
                  </button>
                </div>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="rememberMe"
                      checked={rememberMe}
                      onChange={(e) => setRememberMe(e.target.checked)}
                    />
                    <label className="form-check-label" htmlFor="rememberMe">
                      Se souvenir de moi
                    </label>
                  </div>
                  <a href="/reinitialiser_mot_de_passe" className='btn-cnx'>Mot de passe oublié ?</a>
                </div>
                <div className="d-grid gap-2">
                  <button
                    type="button"
                    className="btn btn-primary btn-lg"
                    onClick={handleLogin}
                    disabled={status.loading}
                  >
                    {status.loading ? '...' : 'Je me connecte'}
                  </button>
                </div>

                {status.error && (
                  <div className="alert alert-danger mt-3" role="alert">
                    {status.error}
                  </div>
                )}
              </form>
            </div>
          </div>

          {/* Partner Benefits Column */}
          <div className="col-md-6 mb-4 d-none d-md-block">
            <div className="card shadow-sm h-100" style={{ borderColor: '#0044ab', borderWidth: '2px' }}>
              <div className="card-body text-center d-flex flex-column justify-content-center">
                <h5 className="mb-3" style={{ color: '#0044ab' }}>Pas encore de compte fournisseur ?</h5>
                <p className="text-muted mb-4">
                  Rejoins notre réseau de partenaires et bénéficie d'un
                  accompagnement personnalisé pour un accès dédié à la gestion de livraison
                </p>

                <ul className="text-muted mb-4 text-start fs-5">
                  <li className="mb-2">
                    <strong>Gagne du temps :</strong> nous récupérons tes produits directement chez toi et gérons la livraison.
                  </li>
                  <li className="mb-2">
                    <strong>Offre une expérience premium :</strong> tes clients reçoivent leurs commandes rapidement et sans effort.
                  </li>
                  <li className="mb-2">
                    <strong>Simplifie tes opérations :</strong> Chacun se concentre sur sa valeur ajoutée
                  </li>
                </ul>

                <a
                  href="mailto:contact@marion-materiaux.com?subject=Devenir%20partenaire"
                  className="btn w-100"
                  style={{
                    borderColor: '#0044ab',
                    color: '#0044ab',
                    backgroundColor: 'transparent'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#0044ab';
                    e.target.style.color = 'white';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = 'transparent';
                    e.target.style.color = '#0044ab';
                  }}
                >
                  Nous contacter pour devenir fournisseur
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginScreen;
